// Copyright (c) 2026 Endel Dreyer.
//
// This software is released under the MIT License.
// https://opensource.org/license/MIT
//
// colyseus.js@0.17.34
function now() {
    return typeof (performance) !== 'undefined' ? performance.now() : Date.now();
}

export { now };
//# sourceMappingURL=utils.mjs.map
